import i18n from '@/locales'
import { currencyUnitMap } from '@/constants/currency'
import { ELEMENT_TYPES } from '../constants'

export const getReportElementTypeColumn = () => {
  return {
    title: i18n.t('report.element_type'),
    field: 'element_type',
    formatter: ({ row }) => {
      const target = ELEMENT_TYPES.filter(item => item.key === row.element_type)
      return target.length ? target[0].label : '-'
    },
  }
}

export const getReportElementKeyColumn = () => {
  return {
    field: 'element_key',
    title: i18n.t('report.column_value'),
    formatter: ({ row }) => {
      const { element_type, element_key, element_value, name } = row
      if (['usage', 'metric'].includes(element_type)) {
        return `${element_key}（${name}）`
      } else if (element_type === 'metadata') {
        return (element_key || '').replace('user:', '')
      } else if (element_type === 'constant') {
        return element_value
      } else if (element_type === 'meter') {
        if (currencyUnitMap[element_key]) {
          return i18n.t('bill.text_39', [currencyUnitMap[element_key].label])
        }
      } else if (element_type === 'attribute') {
        return element_key
      }
      return '-'
    },
  }
}

export const getReportElementValueTypeColumn = () => {
  return {
    field: 'value_type',
    title: i18n.t('report.value_type'),
    formatter: ({ row }) => {
      return i18n.t(`report.value_type.${row.value_type || 'string'}`)
    },
  }
}

export const getReportElementCalcColumn = () => {
  return {
    field: 'calc',
    title: i18n.t('report.value_expression'),
    formatter: ({ row }) => {
      return row.calc || 'x'
    },
  }
}

export const getReportElementPeriodColumn = () => {
  return {
    field: 'period',
    title: i18n.t('report.time_range'),
    formatter: ({ row }) => {
      return row.period ? `${row.period} ${i18n.t(`report.time_range_unit.${row.period_unit || 'hour'}`)}` : '-'
    },
  }
}
